function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 531.22,
    y: 183.59,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1091.8986 516.1398)",
    style: {
      fill: "#1A2E35"
    },
    width: 29.46,
    height: 148.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9729 -0.2313 0.2313 0.9729 -133.4922 244.6221)",
    style: {
      fill: "#00A1DF"
    },
    cx: 976.44,
    cy: 691.59,
    rx: 86.56,
    ry: 86.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9752 -0.2212 0.2212 0.9752 -149.1865 39.6798)",
    style: {
      fill: "#00A1DF"
    },
    cx: 102.56,
    cy: 685.89,
    rx: 86.56,
    ry: 86.56
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC0712"
    },
    d: "M528.77,300.25c0,0-351.96-4.23-407.68,300.61C65.38,905.71,363.02,911.4,448.63,917.18 c38.82,2.62,121.87,2.89,195.16,1.62c162.24-2.82,276.89-34.22,315.9-184.74c4.55-17.55,7.62-35.57,8.76-53.91 C978.76,515.16,867.09,292.13,528.77,300.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M784.09,764.55l-511.33,7.98c-53.6,0.84-97.72-41.93-98.56-95.53l0,0 c-0.84-53.6,41.93-97.72,95.53-98.56l511.33-7.98c53.6-0.84,97.72,41.93,98.56,95.53l0,0 C880.46,719.59,837.69,763.72,784.09,764.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2E35"
    },
    d: "M378.87,666.42c-3.31,16.88-19.67,27.89-36.55,24.58c-16.88-3.31-27.89-19.67-24.58-36.55 c3.31-16.88,19.67-27.89,36.55-24.58C371.17,633.18,382.17,649.54,378.87,666.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2E35"
    },
    d: "M736.09,660.72c-3.31,16.88-19.67,27.89-36.55,24.58c-16.88-3.31-27.88-19.67-24.58-36.55 c3.31-16.88,19.67-27.89,36.55-24.58C728.4,627.48,739.4,643.84,736.09,660.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 32.187 438.9468)",
    style: {
      fill: "#00A1DF"
    },
    cx: 545.95,
    cy: 180.62,
    rx: 48.55,
    ry: 48.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2E35"
    },
    d: "M468.41,652.06c2.32,0.25,1.16,11.14,7.96,25.62c3.28,7.19,8.75,15.05,16.53,21.73 c7.72,6.69,18,11.82,29.26,12.98c11.29,0.9,22.33-2.29,31.14-7.47c8.86-5.16,15.66-11.9,20.2-18.38 c9.31-13.01,10.15-23.93,12.47-23.76c0.91,0.02,1.85,2.77,1.85,7.92c0.03,5.14-1.46,12.67-5.67,21.04 c-4.16,8.36-11.41,17.31-21.87,24.33c-10.34,7.01-24.36,11.77-39.42,10.54c-15.03-1.52-27.96-8.74-36.85-17.51 c-9.01-8.79-14.52-18.91-17.1-27.89c-2.62-8.99-2.73-16.66-1.76-21.72C466.08,654.44,467.51,651.91,468.41,652.06z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2E35"
    },
    d: "M937.03,794.21c-0.52-0.3,5.79-9.87,11.86-27.16c6.23-17.19,11.67-42.08,14.27-69.91 c2.78-27.85,2.36-53.27,1.65-71.59c-0.43-9.17-0.86-16.59-1.27-21.71c-0.37-5.13-0.48-7.98-0.28-8c0.2-0.02,0.68,2.78,1.39,7.89 c0.75,5.1,1.49,12.52,2.18,21.71c1.23,18.37,1.98,43.93-0.82,71.98c-2.62,28.03-8.43,53.13-15.22,70.34 c-3.3,8.64-6.71,15.34-9.32,19.79C938.77,791.94,937.2,794.32,937.03,794.21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2E35"
    },
    d: "M121.89,590.91c0.19,0.06-0.44,2.85-1.74,7.83c-0.68,2.48-1.47,5.52-2.19,9.1 c-0.75,3.57-1.79,7.6-2.47,12.14c-1.71,9.02-3.05,19.87-3.86,31.96c-0.63,12.1-0.62,25.44,0.56,39.38 c1.3,13.93,3.64,27.07,6.39,38.88c2.92,11.76,6.15,22.21,9.43,30.79c1.47,4.35,3.2,8.13,4.57,11.51c1.34,3.4,2.65,6.25,3.76,8.58 c2.15,4.67,3.26,7.31,3.09,7.4c-0.17,0.09-1.62-2.37-4.09-6.91c-1.26-2.26-2.73-5.06-4.22-8.42c-1.51-3.34-3.39-7.1-4.99-11.44 c-3.54-8.55-7.01-19.04-10.1-30.89c-2.92-11.89-5.36-25.17-6.68-39.25c-1.19-14.09-1.12-27.59-0.34-39.81 c0.95-12.21,2.52-23.14,4.5-32.18c0.82-4.56,2-8.58,2.9-12.14c0.87-3.57,1.83-6.58,2.67-9.03 C120.71,593.52,121.7,590.85,121.89,590.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M484.22,323.06c0,0.05-0.43,0.12-1.27,0.21c-1.01,0.09-2.23,0.2-3.72,0.34 c-3.27,0.34-8.11,0.44-14.29,1.18c-12.39,1.12-30.28,3.57-51.94,8.61c-21.66,5.01-46.99,13.12-73.66,25.48 c-26.66,12.31-54.47,29.19-80.7,50.66c-26.07,21.69-47.92,45.79-65.07,69.64c-17.19,23.84-29.97,47.18-38.99,67.49 c-9.06,20.31-14.85,37.41-18.31,49.36c-1.9,5.93-2.92,10.66-3.87,13.81c-0.42,1.44-0.76,2.62-1.04,3.59 c-0.25,0.81-0.4,1.21-0.45,1.2c-0.05-0.01,0.01-0.44,0.16-1.27c0.21-0.99,0.46-2.19,0.76-3.66c0.77-3.19,1.62-7.98,3.36-13.97 c3.14-12.08,8.66-29.36,17.53-49.88c8.84-20.53,21.51-44.11,38.7-68.21c17.15-24.09,39.11-48.45,65.39-70.3 c26.44-21.65,54.51-38.59,81.42-50.85c26.91-12.31,52.48-20.28,74.31-25.06c21.83-4.82,39.84-6.96,52.3-7.75 c6.22-0.57,11.08-0.5,14.36-0.65c1.5-0.02,2.72-0.04,3.74-0.05C483.78,322.98,484.22,323.01,484.22,323.06z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.83,745.35c-0.33,0.13-2.45-3.96-5-10.95c-2.56-6.98-5.39-16.92-7.16-28.16 c-1.75-11.25-2.1-21.58-1.8-29.01c0.29-7.44,1.06-11.99,1.41-11.96c0.9,0.04-0.35,18.36,3.21,40.52 C133.89,727.97,140.67,745.03,139.83,745.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M47.52,717c-0.14,0.11-1.24-0.89-2.97-2.96c-1.73-2.06-3.98-5.28-6.2-9.58 c-4.47-8.5-8.36-22-6.4-36.87c1.98-14.87,9.26-26.9,15.79-33.93c3.27-3.57,6.28-6.09,8.49-7.64c2.2-1.55,3.54-2.23,3.64-2.08 c0.32,0.41-4.63,3.76-10.59,11.03c-5.95,7.16-12.6,18.82-14.49,32.99c-1.87,14.17,1.51,27.15,5.39,35.62 C44.03,712.17,47.93,716.69,47.52,717z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M549.17,146.78c-0.12,0.54-5.01-1.26-12.91-0.32c-7.7,0.81-18.78,5.25-25.35,15.34 c-6.44,10.18-5.87,22.1-3.39,29.44c2.43,7.58,6.1,11.27,5.66,11.61c-0.12,0.12-1.14-0.67-2.65-2.43c-1.52-1.75-3.38-4.61-4.92-8.5 c-3.11-7.58-4.17-20.45,2.9-31.65c7.24-11.08,19.38-15.47,27.57-15.8c4.18-0.23,7.55,0.28,9.78,0.93 C548.08,146.03,549.22,146.62,549.17,146.78z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1027.24,650.46c-0.6,0.65-9.14-7.5-22.03-13.67c-12.83-6.31-24.51-7.97-24.37-8.84 c-0.02-0.7,12.26-0.28,25.62,6.27C1019.87,640.66,1027.81,650.05,1027.24,650.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M699.6,552.6c0,0.79-67.35,1.43-150.42,1.43c-83.09,0-150.43-0.64-150.43-1.43 c0-0.79,67.34-1.43,150.43-1.43C632.24,551.17,699.6,551.81,699.6,552.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M442.91,895.6c0.01,0.1-0.87,0.24-2.54,0.41c-2.01,0.17-4.43,0.38-7.34,0.63 c-3.19,0.27-7.09,0.53-11.64,0.6c-4.54,0.1-9.72,0.36-15.44,0.18c-11.45-0.03-25.07-0.81-40.13-2.41 c-15.04-1.76-31.5-4.42-48.53-8.37c-17.01-4.07-32.93-9.03-47.18-14.17c-14.19-5.29-26.74-10.67-36.99-15.75 c-5.2-2.39-9.72-4.94-13.74-7.05c-4.04-2.09-7.42-4.06-10.15-5.73c-2.49-1.52-4.56-2.79-6.28-3.84c-1.42-0.9-2.14-1.42-2.09-1.51 c0.05-0.09,0.87,0.26,2.38,1.01c1.79,0.92,3.95,2.03,6.54,3.37c2.81,1.51,6.25,3.33,10.34,5.28c4.08,1.97,8.64,4.38,13.86,6.64 c10.32,4.83,22.87,9.98,37.02,15.1c14.21,4.97,30.04,9.82,46.94,13.86c16.92,3.92,33.25,6.65,48.18,8.54 c14.95,1.73,28.48,2.72,39.87,3c5.69,0.31,10.84,0.19,15.37,0.24c4.53,0.08,8.43-0.01,11.62-0.11c2.91-0.04,5.34-0.07,7.35-0.1 C442.01,895.45,442.9,895.5,442.91,895.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.b64a21e8264e66777cb5097cc646a0f6.svg";
export { ForwardRef as ReactComponent };